<div [formGroup]="form()">
  <mat-card>
    <mat-card-title class="title">BASIC DEFINITIONS</mat-card-title>
    <div class="middlecards">
      <mat-form-field>
        <input
          value="{{ recommendations().concernsName }} - {{ recommendations().concernsCountry }}"
          matInput
          placeholder="Concern"
          disabled />
      </mat-form-field>
    </div>
    <div class="middlecards">
      <mat-form-field>
        <input
          [value]="form().get('reportingYear')?.value"
          matInput
          placeholder="Report Year"
          disabled />
      </mat-form-field>
      <mat-form-field>
        <input
          [value]="form().get('legalUnit')?.value"
          matInput
          placeholder="Legal Unit"
          disabled />
      </mat-form-field>
      <mat-form-field>
        <input
          [value]="form().get('department')?.value"
          matInput
          placeholder="BG"
          disabled />
      </mat-form-field>
    </div>
    <p class="title">Document creation</p>
    <div class="middlecards">
      <mat-form-field>
        <input
          [value]="form().value.prolongationDeadline | date : 'dd.MM.yyyy' : '+0000'"
          matInput
          placeholder="Prolognation deadline"
          disabled />
      </mat-form-field>
      <mat-form-field>
        <input
          [value]="
            (form().get('createdBy')?.value | userName | async) +
            ' ' +
            (form().get('createdBy')?.value | azureIdStatus | async)
          "
          matInput
          placeholder="Creator"
          disabled />
      </mat-form-field>
      <mat-form-field>
        <input
          [value]="form().get('auditor')?.value"
          matInput
          placeholder="Auditor"
          disabled />
      </mat-form-field>
    </div>
  </mat-card>
  <mat-card>
    <mat-card-title class="title">RESPONSIBLES</mat-card-title>
    <div class="middlecards">
      <mat-form-field>
        <input
          matInput
          [value]="form().get('assessmentCoordinatorName')?.value"
          placeholder="Auditee"
          disabled />
      </mat-form-field>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Legal Unit Responsible(s) </mat-panel-title>
          </mat-expansion-panel-header>
          @for (responsible of recommendations().legalUnitResponsibles; track responsible; let i = $index) {
          <div class="col-md-10">
            {{ responsible | userName: (recommendations().legalUnitResponsiblesNames || [])[i] | async }}
            {{ responsible | azureIdStatus | async }}
          </div>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-card>
</div>
